export const MERGE_ENTITIES = 'waitrose/entities/MERGE_ENTITIES' as const;
export const SET_BRANCH_NAME = 'waitrose/entities/orders/SET_BRANCH_NAME' as const;
export const REMOVE_SHELF_LIFE = 'waitrose/entities/REMOVE_SHELF_LIFE' as const;

export const MERGE_EXPERIENCE_FRAGMENT_CAROUSEL_PRODUCT_ENTITIES =
  'waitrose/entities/MERGE_EXPERIENCE_FRAGMENT_CAROUSEL_PRODUCT_ENTITIES' as const;
